{
  "slug": "are-iq-tests-timed",
  "title": "Are IQ Tests Timed?",
  "description": "Learn which IQ-test tasks use time limits, why processing speed is measured, and when rushing can reduce accuracy.",
  "summary": "Many intelligence tests combine timed and less speeded tasks. Time can be part of the construct for some subtests, but it should not be treated as equally important everywhere.",
  "category": "IQ questions answered",
  "sections": [
    {
      "heading": "Why some tasks use a clock",
      "paragraphs": [
        "Processing-speed tasks examine how efficiently a person performs simple, well-defined work under standardized limits. Other reasoning tasks may award points mainly for correct solutions, sometimes with secondary timing rules.",
        "The timer helps make administrations comparable. It does not mean that every form of intelligence is speed."
      ]
    },
    {
      "heading": "How to respond to time limits",
      "paragraphs": [
        "Read the instructions before starting, work steadily, and avoid spending most of the section on one item unless the rules encourage it. Guessing policies and navigation rules vary by test.",
        "On untimed or lightly timed tasks, deliberate reasoning may be more useful than rushing. Let the instructions—not assumptions—set your pace."
      ]
    },
    {
      "heading": "Accessibility and interpretation",
      "paragraphs": [
        "Motor, visual, hearing, language, attention, or health factors can influence timed performance. Professional testing may use approved accommodations or interpret speed scores with added context.",
        "Changing a time limit without a standardized basis can change score meaning. Online results should state whether timing influenced the estimate."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Does taking longer always mean a lower IQ?",
      "answer": "No. Timing rules differ, and many tasks value accuracy more than speed."
    },
    {
      "question": "Can I pause a timed online test?",
      "answer": "Only if the instructions allow it; pausing can make your conditions incomparable with the stated scoring method."
    }
  ],
  "related": [
    "how-long-does-an-iq-test-take",
    "processing-speed-explained",
    "iq-test-instructions-explained",
    "iq-test-accommodations-and-accessibility"
  ],
  "sources": [
    {
      "label": "Pearson — WAIS-5 sample score report",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report-with-demographically-referenced-scores.pdf"
    },
    {
      "label": "Standards for Educational and Psychological Testing",
      "url": "https://www.testingstandards.net/"
    }
  ]
}
